import type { LoginResponse, LoginUser, Permissions } from '@/shared/api';
import { apiRequest } from '@/shared/api';

export type { LoginUser, Permissions };

export interface CreateInviteResponse {
  token: string;
  expires_at: string;
  role_key: string;
  invite_path: string;
}

export interface PendingInvite {
  id: string;
  role_key: string;
  expires_at: string;
  created_at: string;
}

export interface InvitePreview {
  role_key: string;
  expires_at: string;
}

export interface UpdateMePayload {
  name?: string;
  current_password?: string;
  new_password?: string;
}

export async function login(email: string, password: string): Promise<LoginResponse> {
  return apiRequest<LoginResponse>('/auth/login', {
    method: 'POST',
    body: { email, password },
    auth: false,
  });
}

export async function pingAuth(): Promise<{
  ok: boolean;
  user_id: string;
  email: string;
  role: string;
}> {
  return apiRequest('/auth/ping');
}

export async function getMe(): Promise<LoginUser> {
  return apiRequest<LoginUser>('/auth/me');
}

export async function updateMe(payload: UpdateMePayload): Promise<LoginUser> {
  return apiRequest<LoginUser>('/auth/me', {
    method: 'PATCH',
    body: payload,
  });
}

export async function createInvite(roleKey: string): Promise<CreateInviteResponse> {
  return apiRequest<CreateInviteResponse>('/auth/invites', {
    method: 'POST',
    body: { role_key: roleKey },
  });
}

export async function listInvites(): Promise<PendingInvite[]> {
  const data = await apiRequest<{ invites: PendingInvite[] }>('/auth/invites');
  return data.invites;
}

export async function getInvite(token: string): Promise<InvitePreview> {
  return apiRequest<InvitePreview>(`/auth/invites/${encodeURIComponent(token)}`, {
    auth: false,
  });
}

export async function acceptInvite(
  token: string,
  email: string,
  password: string,
): Promise<LoginResponse> {
  return apiRequest<LoginResponse>(`/auth/invites/${encodeURIComponent(token)}/accept`, {
    method: 'POST',
    body: { email, password },
    auth: false,
  });
}
